import { Component } from 'react';
import ViralTrackingPixel from 'viral-links-lib/viral-tracking/ViralTrackingPixel';
import { jsx as _jsx } from "react/jsx-runtime";
export default class FreemiumViralTrackingPixel extends Component {
  render() {
    const {
      embedded,
      portalId,
      viralLinkType
    } = this.props;
    const linkType = embedded ? `${viralLinkType}-embedded` : `${viralLinkType}`;
    return /*#__PURE__*/_jsx(ViralTrackingPixel, {
      portalId: portalId,
      viralLinkType: linkType,
      isExternalLink: embedded
    });
  }
}